'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'CELL_01',
	name: 'Cell',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['CELL_01'],
	category: 'Layout',
	props: [{
		name: 'lg-size',
		inputType: 'select',
		label: 'Desktop size',
		default: 'full',
		values: ['1of12', '2of12', '3of12', '4of12', '5of12', '6of12', '7of12', '8of12', '9of12', '10of12', '11of12', 'full', 'hidden']
	}, {
		name: 'md-size',
		inputType: 'select',
		label: 'Tablet size',
		default: 'full',
		values: ['1of12', '2of12', '3of12', '4of12', '5of12', '6of12', '7of12', '8of12', '9of12', '10of12', '11of12', 'full', 'hidden']
	}, {
		name: 'size',
		inputType: 'select',
		label: 'Mobile size',
		default: 'full',
		values: ['1of12', '2of12', '3of12', '4of12', '5of12', '6of12', '7of12', '8of12', '9of12', '10of12', '11of12', 'full', 'hidden']
	}],
	hiddenProps: (0, _applyConfigs2.default)(['animations', 'htmlclass']).concat({
		label: 'Cell order',
		props: [{
			name: 'u-lg-flexOrder',
			inputType: 'select',
			label: 'Desktop order',
			default: 'None',
			values: ['None', 'First', 'Last']
		}, {
			name: 'u-md-flexOrder',
			inputType: 'select',
			label: 'Tablet order',
			default: 'None',
			values: ['None', 'First', 'Last']
		}, {
			name: 'u-sm-flexOrder',
			inputType: 'select',
			label: 'Mobile order',
			default: 'None',
			values: ['None', 'First', 'Last']
		}]
	})
};